import { GetThePhoneCallCallerNameForAnIdoAndInstanceQueryReturn } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

import { SetThePhoneCallCallerNameForAContactPersonInAnIdoAndInstancePayload } from '../interfaces';

export class GetThePhoneCallCallerNameForAContactPersonInAnIdoAndInstanceQueryCallback extends Callback<GetThePhoneCallCallerNameForAnIdoAndInstanceQueryReturn> {
	public constructor(
		private readonly callerNumber: string,
		private readonly idoRecordIdentifierOrAggregateId: string,
		private readonly setThePhoneCallCallerNameForAContactPersonInAnIdoAndInstance: (
			payload: SetThePhoneCallCallerNameForAContactPersonInAnIdoAndInstancePayload
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: GetThePhoneCallCallerNameForAnIdoAndInstanceQueryReturn): void => {
		this.setThePhoneCallCallerNameForAContactPersonInAnIdoAndInstance({
			callerName: successResponse.callerName,
			callerNumber: this.callerNumber,
			idoRecordIdentifierOrAggregateId: this.idoRecordIdentifierOrAggregateId,
		});
	};
}
